export function useCatPresup() {

  
  function construirEstructura(data) {
  const agrupador = {};

  data.forEach((item) => {
    const categoriaId = item.categoria_id;
    const centroId = item.centro_id;
    const monto = parseFloat(item?.total_presupuesto) || 0;
    const gastos = parseFloat(item?.total_gastos) || 0;

    // Inicializar categoría
    if (!agrupador[categoriaId]) {
      agrupador[categoriaId] = {};
    }

    // Inicializar centro dentro de la categoría
    if (!agrupador[categoriaId][centroId]) {
      agrupador[categoriaId][centroId] = {
        presupuestos: 0,
        gastos: 0,
      };
    }

    // Acumular montos
    agrupador[categoriaId][centroId].presupuestos += monto;
    agrupador[categoriaId][centroId].gastos += gastos;
  });

  // Convertir a la estructura final
  const categorias = Object.keys(agrupador).map((categoriaId) => {
    const centrosData = agrupador[categoriaId];

    const centros = Object.keys(centrosData).map((centroId) => ({
      centro_id: parseInt(centroId),
      total_presupuestos: centrosData[centroId].presupuestos.toString(),
      total_gastos: centrosData[centroId].gastos.toString(),
      total_saldo: parseFloat( parseFloat(centrosData[centroId].presupuestos) - parseFloat(centrosData[centroId].gastos))
    }));

    return {
      categoria_id: parseInt(categoriaId),
      centros: centros,
    };
  });

  return categorias;
}
  function getCatPresup(presupuestos, cuentas) {
    /*
       array de objetos 'presupuestos':
     
               {
                        "id": 5816,
                        "centro_id": 6,
                        "cuenta_id": 8,
                        "empresa_id": 1,
                        "aa": 2025,
                        "moneda_id": 1,
                        "total_presupuesto": "900000.00",
                        "total_gastos": "0.00",
                         "clasificacioncentro_id": 4
                    },
      */

    let categorias = [];
    let cuentasCoincidentes;
    // crea vector de cuentas en presupuestos
    const cuentasIdSet = new Set(presupuestos.map((p) => p.cuenta_id));
    // haz match
    cuentasCoincidentes = cuentas.filter((c) => cuentasIdSet.has(c.id));

    /*
         {
        "id": 38,
        "codigo": "4510305004",
        "nombre": "Viajes de prensa, institucionales",
        "tipo_cuenta": {
            "id": 8,
            "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
            "categoria_cuenta": {
                "id": 5,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "orden":1
            }
        }
        }
]
        */
    cuentasCoincidentes.forEach((cuenta) => {
      const cat = cuenta.tipo_cuenta.categoria_cuenta;
      const tip = cuenta.tipo_cuenta;
      const codigocta = cuenta.codigo;
      const idcta = cuenta.id;
      const nomcta = cuenta.nombre;
      const presup = presupuestos.filter((p) => p.cuenta_id === cuenta.id);

      let total_presupuesto = 0;
      let total_gastos = 0;
      let saldo = 0;
      if (Array.isArray(presup)) {
        const totales = presup.reduce(
          (acc, item) => {
            acc.total_presupuesto += Number(item?.total_presupuesto || 0);
            acc.total_gastos += Number(item.total_gastos || 0);
            return acc;
          },
          { total_presupuesto: 0, total_gastos: 0 },
        );

        total_presupuesto = totales?.total_presupuesto;
        total_gastos = totales.total_gastos;
        saldo = total_presupuesto - total_gastos;
      }

      if (!categorias[cat.id]) {
        categorias[cat.id] = {
          id: cat.id,
          nombre: cat.nombre,
          tipos: [],
          orden: cat.orden,
        };
      }
      // busca tipos
      let tipos = categorias[cat.id].tipos;
      let existeTipo = tipos.find((tipo) => tipo.id === tip.id);
      if (typeof existeTipo == "undefined") {
        tipos.push({
          id: tip.id,
          nombre: tip.nombre,
          cuentas: [
            {
              id: idcta,
              cod: codigocta,
              nomcta: nomcta,
              total_presupuesto: total_presupuesto,
              total_gastos: total_gastos,
              saldo: saldo,
            },
          ],
        });
        categorias[cat.id].tipos = tipos;
      } else {
        existeTipo.cuentas.push({
          id: idcta,
          cod: codigocta,
          nomcta: nomcta,
          total_presupuesto: total_presupuesto,
          total_gastos: total_gastos,
          saldo: saldo,
        });
        categorias[cat.id].tipos.cuentas = existeTipo;
      }
    });

    // 1️⃣ Ordenar las categorías por nombre
    // Object.values(categorias)
    // Convierte categorias en array si fuera un objeto.
    /**
           * {
            1:{nombre:"A"},
            2:{nombre:"B"}
          }
            convierte a: 
          [
          {nombre:"A"},
          {nombre:"B"}
          ]
          .sort() --> Ordena el array.
          localeCompare --> Ordena alfabéticamente respetando acentos y mayúsculas.
           */
    categorias = Object.values(categorias).sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );

    //2️⃣ Ordenar los tipos dentro de cada categoría
    categorias.forEach((cat) => {
      if (Array.isArray(cat.tipos)) {
        cat.tipos.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
    });

    // 3️⃣ Ordenar las cuentas dentro de cada tipo
    categorias.forEach((cat) => {
      if (Array.isArray(cat.tipos)) {
        cat.tipos.forEach((tip) => {
          if (Array.isArray(tip.cuentas)) {
            tip.cuentas.sort((a, b) => a.cod.localeCompare(b.cod));
          }
        });
      }
    });

    return categorias;
  }
  function getCatPresupV2(presupuestos, cuentas) {
    /*
       array de objetos 'presupuestos':
     
               {
                        "id": 5816,
                        "centro_id": 6,
                        "cuenta_id": 8,
                        "empresa_id": 1,
                        "aa": 2025,
                        "moneda_id": 1,
                        "total_presupuesto": "900000.00",
                        "total_gastos": "0.00",
                         "clasificacioncentro_id": 4
                    },
      */
    let catctas = [];
    let categorias = [];
    let cuentasCoincidentes;
    // crea vector de cuentas en presupuestos
    const cuentasIdSet = new Set(presupuestos.map((p) => p.cuenta_id));
    // haz match
    cuentasCoincidentes = cuentas.filter((c) => cuentasIdSet.has(c.id));

    /*
         {
        "id": 38,
        "codigo": "4510305004",
        "nombre": "Viajes de prensa, institucionales",
        "tipo_cuenta": {
            "id": 8,
            "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
            "categoria_cuenta": {
                "id": 5,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "orden":1
            }
        }
        }
]
        */
    const resultado = construirEstructura(presupuestos);
    catctas.push(resultado);

    cuentasCoincidentes.forEach((cuenta) => {
      const cat = cuenta.tipo_cuenta.categoria_cuenta;

      const tip = cuenta.tipo_cuenta;
      const codigocta = cuenta.codigo;
      const idcta = cuenta.id;
      const nomcta = cuenta.nombre;
      const presup = presupuestos.filter((p) => p.cuenta_id === cuenta.id);

      /*
               console.log( presup)
             [
                {
                    "id": 5067,
                    "centro_id": 40,
                    "categoria_id": 5,
                    "tipo_id": 8,
                    "cuenta_id": 43,
                    "empresa_id": 1,
                    "aa": 2026,
                    "moneda_id": 1,
                    "total_presupuesto": "3950000.00",
                    "total_gastos": "475881.00",
                    "clasificacioncentro_id": 6
                },
                {
                    "id": 1108,
                    "centro_id": 9,
                    "categoria_id": 5,
                    "tipo_id": 8,
                    "cuenta_id": 43,
                    "empresa_id": 1,
                    "aa": 2026,
                    "moneda_id": 1,
                    "total_presupuesto": "2000000.00",
                    "total_gastos": "476353.00",
                    "clasificacioncentro_id": 7
                }
            ]
              */
      let total_presupuesto = 0;
      let total_gastos = 0;
      let saldo = 0;
      if (Array.isArray(presup)) {
        const totales = presup.reduce(
          (acc, item) => {
            acc.total_presupuesto += Number(item?.total_presupuesto || 0);
            acc.total_gastos += Number(item?.total_gastos || 0);
            return acc;
          },
          { total_presupuesto: 0, total_gastos: 0 },
        );

        total_presupuesto =  Number( totales?.total_presupuesto || 0);
        total_gastos = totales.total_gastos;
        saldo = total_presupuesto - total_gastos;
      }

      if (!categorias[cat.id]) {
        categorias[cat.id] = {
          id: cat.id,
          nombre: cat.nombre,
          tipos: [],
          centros: [],
          orden: cat.orden,
        };
      }
      // busca tipos
      let tipos = categorias[cat.id].tipos;
      let existeTipo = tipos.find((tipo) => tipo.id === tip.id);
      if (typeof existeTipo == "undefined") {
        tipos.push({
          id: tip.id,
          nombre: tip.nombre,
          cuentas: [
            {
              id: idcta,
              cod: codigocta,
              nomcta: nomcta,
              total_presupuesto: total_presupuesto,
              total_gastos: total_gastos,
              saldo: saldo,
            },
          ],
        });

        categorias[cat.id].tipos = tipos;
      } else {
        existeTipo.cuentas.push({
          id: idcta,
          cod: codigocta,
          nomcta: nomcta,
          total_presupuesto: total_presupuesto,
          total_gastos: total_gastos,
          saldo: saldo,
        });
        categorias[cat.id].tipos.cuentas = existeTipo;
      }
    });

    /*
console.log('categorias',categorias)

[
    null,
    {
        "id": 1,
        "nombre": "GASTOS DEL PERSONAL",
        "tipos": [
            {
                "id": 1,
                "nombre": "GASTOS DEL PERSONAL",
                "cuentas": [
                    {
                        "id": 1,
                        "cod": "4510301001",
                        "nomcta": "Remuneraciones",
                        "total_presupuesto": 2222989858.2,
                        "total_gastos": 1067805998,
                        "saldo": 1155183860.1999998
                    },
                    {
                        "id": 3,
                        "cod": "4510301003",
                        "nomcta": "Vacaciones Proporcionales",
                        "total_presupuesto": 0,
                        "total_gastos": 17341026,
                        "saldo": -17341026
                    } 
                ]
            }
        ],
        "orden": 1
    } 
    ]
*/

    // 1️⃣ Ordenar las categorías por nombre
    // Object.values(categorias)
    // Convierte categorias en array si fuera un objeto.
    /**
          {
            1:{nombre:"A"},
            2:{nombre:"B"}
          }
            convierte a: 
          [
          {nombre:"A"},
          {nombre:"B"}
          ]
          .sort() --> Ordena el array.
          localeCompare --> Ordena alfabéticamente respetando acentos y mayúsculas.
    */

    categorias = Object.values(categorias).sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );

    //2️⃣ Ordenar los tipos dentro de cada categoría
    categorias.forEach((cat) => {
      if (Array.isArray(cat.tipos)) {
        cat.tipos.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
    });

    // 3️⃣ Ordenar las cuentas dentro de cada tipo
    categorias.forEach((cat) => {
      if (Array.isArray(cat.tipos)) {
        cat.tipos.forEach((tip) => {
          if (Array.isArray(tip.cuentas)) {
            tip.cuentas.sort((a, b) => a.cod.localeCompare(b.cod));
          }
        });
      }
    });

    return { categorias, catctas };
  }

  return { getCatPresup, getCatPresupV2 };
}
